import React from 'react';

export const PeopleBanner = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    return (
        <section className="pr relative md:gutter top bg-gradient-to-t from-grey-light to-white">
            <svg id="visual" viewBox="0 0 960 540" preserveAspectRatio="none" className="absolute hidden md:block bottom-0 w-full -bottom-px" width="100%" height="540" xmlns="http://www.w3.org/2000/svg" version="1.1"><path d="M0 421L40 435.7C80 450.3 160 479.7 240 474.5C320 469.3 400 429.7 480 416.5C560 403.3 640 416.7 720 410.3C800 404 880 378 920 365L960 352L960 541L920 541C880 541 800 541 720 541C640 541 560 541 480 541C400 541 320 541 240 541C160 541 80 541 40 541L0 541Z" fill="#fff" strokeLinecap="round" strokeLinejoin="miter"></path></svg>
            
                <div className="banner wrapper flex flex-col md:flex-row justify-between items-center md:pt-8 gap-12 md:gap-24">
                    <div className="w-full pt-8 pb-8 md:pb-12 md:w-3/5 text-grey">
                        <h1 className="mb-0 md:mb-2 text-2xl md:!text-5xl">{sc.name.text}</h1>
                        <div className="text-xl md:text-2xl">{sc.co_title}</div>
                    </div>
                    
                </div>
            </section>
        
    );
}

